// todo: extract tabs as separate classes with baseclass - will remove callbacks passed as strings

import Axios from "axios";

export const AuthModal = {
	selectors: {
		tabs: Array.prototype.slice.call(
			document.querySelectorAll(".js-auth-tab")
		),
		nav: document.querySelector(".js-auth-nav"),
		navTabs: Array.prototype.slice.call(
			document.querySelectorAll(".js-auth-nav-tab")
		),
		contentTabs: Array.prototype.slice.call(
			document.querySelectorAll(".js-auth-content-tab")
		),
		forms: Array.prototype.slice.call(
			document.querySelectorAll(".js-auth-form")
		),

		// specific
		loginHeaderNormal: document.querySelector(
			".js-auth-login__header--normal"
		),
		loginHeaderClient: document.querySelector(
			".js-auth-login__header--client"
		),
		loginError: document.querySelector(".js-auth-login__error"),
		clientName: document.querySelector(".js-auth-login__client-name"),
		clientEmail: document.querySelector(".js-auth-login__client-email"),
		clientEmailChange: document.querySelector(
			".js-auth-login__client-email-change"
		),
		clientPassword: document.querySelector(
			".js-auth-login__client-password"
		),

		registerContent: document.querySelector(".js-auth-register__content"),

		forgotPasswordSubtitle: document.querySelector(
			".js-auth-forgot-password__subtitle"
		),
		forgotPasswordError: document.querySelector(
			".js-auth-forgot-password__error"
		),
		forgotPasswordContent: document.querySelector(
			".js-auth-forgot-password__content"
		),
		forgotPasswordSuccess: document.querySelector(
			".js-auth-forgot-password__success"
		),

		resetPasswordSubtitle: document.querySelector(
			".js-auth-reset-password__subtitle"
		),
		resetPasswordContent: document.querySelector(
			".js-auth-reset-password__content"
		),
		resetPasswordSuccess: document.querySelector(
			".js-auth-reset-password__success"
		),
	},

	// initiailize whole class
	init: function () {
		// init only if modal is included
		if (
			!document.querySelector(".c-modal--auth") &&
			!document.querySelector(".c-tk-user-login-dialog")
		) {
			return;
		}

		// bind tab change
		this.bindTabs();
		this.bindContent();
		this.bindForms();

		// open default tab - FEKY: handled on backend by get params if needed
		// this.open();
	},

	// used for opening modal with a tab already toggled
	open: function (_target = "tabLogin") {
		// open default tab
		this.closeAllTabs();
		this.openTab(_target);
		this.gaSend(_target);
	},

	// tab controls
	openTab: function (_target) {
		// navigation
		const navTabEls = this.getNavTabs(_target);

		// checking because nav doesnt need to have all the tabs included
		if (navTabEls) {
			navTabEls.forEach((navTabEl) => {
				navTabEl.classList.add("is-active");
			});

			// show navigation
			this.selectors.nav.classList.remove("u-hidden");
		} else {
			// hide navigation
			this.selectors.nav.classList.add("u-hidden");
		}

		// content
		const contentTabEl = this.getContentTab(_target);
		contentTabEl.classList.add("is-active");

		// tab open actions
		this.toggleContent(_target);
	},

	// google analytics data sending
	gaSend: function (_target) {
		if (_target === "tabLogin") {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "ga.pageview",
				virtualPagePath: "/login/sign-in",
				virtualPageTitle: "Přihlásit se | TRAVELKING",
			});
		}
		if (_target === "tabRegister") {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "ga.pageview",
				virtualPagePath: "/login/sign-up",
				virtualPageTitle: "Registrovat se | TRAVELKING",
			});
		}
	},

	closeTab: function (_target) {
		// navigation
		const navTabEls = this.getNavTabs(_target);

		// checking because nav doesnt need to have all the tabs included
		if (navTabEls) {
			navTabEls.forEach((navTabEl) => {
				navTabEl.classList.remove("is-active");
			});
		}

		// content
		const contentTabEl = this.getContentTab(_target);
		contentTabEl.classList.remove("is-active");
	},

	closeAllTabs: function () {
		this.selectors.contentTabs.forEach((tab) => {
			const target = tab.getAttribute("id");
			this.closeTab(target);
		});
	},

	// bindings
	bindTabs: function () {
		this.selectors.tabs.forEach((tab) => {
			tab.addEventListener("click", (event) => {
				event.preventDefault();

				const target = tab.dataset.target;
				const contentTabEl = this.getContentTab(target);

				if (contentTabEl.classList.contains("is-active")) {
					return;
				}

				this.closeAllTabs();
				this.openTab(target);
			});
		});
	},

	bindContent: function () {
		this.tabLoginBind();
	},

	bindForms: function () {
		this.selectors.forms.forEach((form) => {
			form.addEventListener("submit", (event) => {
				event.preventDefault();

				const target = form
					.closest(".c-tab__content")
					.getAttribute("id");
				const button = form.querySelector("button[type=submit]");

				// validate form
				form.reportValidity();

				if (!form || !form.checkValidity()) {
					return;
				}

				// loading state
				button.disabled = true;
				button.classList.add("c-button--disabled");

				// todo: pre-submit
				this.executeCallback(`${target}Presubmit`);

				// submit
				Axios.post(form.dataset.validationUrl, new FormData(form))
					.then((response) => {
						if (response.data.success) {
							form.submit();
						} else {
							// todo: add conditions to callbacks for specific errors?
							this.executeCallback(`${target}Fail`);

							// apply standard form errors
							this.applyFormErrors(response.data.message);

							// todo: remove
							// example
							// this.applyFormErrors({
							// 	errorInputs: [
							// 		"resetPasswordFormEmail",
							// 	],
							// 	messageInput: "resetPasswordFormEmail",
							// 	message: "Hesla se neshodují",
							// });
						}
					})
					.catch((error) => {
						throw new Error(error);
					})
					.finally(() => {
						button.disabled = false;
						button.classList.remove("c-button--disabled");
					});
			});
		});
	},

	applyFormErrors: function (_message) {
		// apply error classes
		const inputs = _message.errorInputs.map((name) =>
			document.querySelector(`input[name=${name}]`)
		);

		inputs.forEach((input) =>
			input.closest(".c-input").classList.add("is-error")
		);

		// apply message
		document
			.querySelector(`input[name=${_message.messageInput}]`)
			.closest(".c-input")
			.querySelector(".c-form-message").innerHTML = _message.message;
	},

	// utilities
	toggleContent: function (_target) {
		this.executeCallback(`${_target}Toggle`);
	},

	getNavTabs: function (_target) {
		return this.selectors.navTabs.filter(
			(x) => x.dataset.target === _target
		);
	},

	getContentTab: function (_target) {
		return this.selectors.contentTabs.find(
			(x) => x.getAttribute("id") === _target
		);
	},

	// tab specific callbacks
	executeCallback: function (_callback, _args) {
		if (this[_callback]) {
			this[_callback](_args);
		}
	},

	tabLoginBind: function () {
		// Change ClientID email to normal
		if (!this.selectors.clientEmailChange) {
			return;
		}

		this.selectors.clientEmailChange.addEventListener("click", () => {
			this.selectors.clientEmail.value = null;
			this.selectors.clientEmailChange.classList.add("u-hidden");
			this.selectors.loginHeaderNormal.classList.remove("u-hidden");
			this.selectors.loginHeaderClient.classList.add("u-hidden");

			if (this.selectors.clientEmailChange.dataset.clearProbableUrl) {
				Axios.get(
					this.selectors.clientEmailChange.dataset.clearProbableUrl
				);
			}
		});
	},
	tabLoginToggle: function () {
		const contentTabEl = document.getElementById("tabLogin");
		const clientName = contentTabEl.dataset.clientName;
		const clientEmail = contentTabEl.dataset.clientEmail;

		// this.selectors.loginError.classList.remove("active");

		if (clientName) {
			// this.selectors.loginHeaderNormal.classList.add("u-hidden");
			// this.selectors.loginHeaderClient.classList.remove("u-hidden");
			if (clientName !== "xyz123") {
				// xyz123 is sent when client has no name filled in
				this.selectors.clientName.innerHTML = ", " + clientName;
			}
			this.selectors.clientEmail.value = clientEmail;
			this.selectors.clientEmailChange.classList.remove("u-hidden");
		} else {
			// this.selectors.loginHeaderNormal.classList.remove("u-hidden");
			// this.selectors.loginHeaderClient.classList.add("u-hidden");
		}
	},
	tabLoginPresubmit: function () {
		this.selectors.loginError.classList.remove("active");
	},
	tabLoginFail: function () {
		this.selectors.loginError.classList.add("active");
	},

	tabRegisterToggle: function () {
		this.selectors.registerContent.classList.remove("u-hidden");
	},
	tabRegisterPresubmit: function () {
		//this.selectors.registerError.classList.remove("active");
	},
	tabRegisterFail: function () {
		//this.selectors.registerError.classList.add("active");
	},

	tabForgotPasswordToggle: function () {
		this.selectors.forgotPasswordError.classList.remove("active");

		this.selectors.forgotPasswordContent.classList.remove("u-hidden");
		this.selectors.forgotPasswordSuccess.classList.add("u-hidden");
	},
	tabForgotPasswordPresubmit: function () {
		// this.selectors.forgotPasswordError.classList.remove("active");
	},
	tabForgotPasswordFail: function () {
		this.selectors.forgotPasswordSubtitle.classList.add("u-hidden");
		this.selectors.forgotPasswordError.classList.add("active");
	},

	tabResetPasswordToggle: function () {
		this.selectors.resetPasswordContent.classList.remove("u-hidden");
		this.selectors.resetPasswordSuccess.classList.add("u-hidden");
	},
};

window.AuthModal = AuthModal;
AuthModal.init();
